import { useState } from "react";

import ImageOnGrid from "../components/ImageOnGrid";
import Modal from "../ui/Modal";

import header_image_2021 from "../assets/dionisiache/header_image_2021.jpg";
import image_2015 from "../assets/dionisiache/image_2015.jpg";
import image_2016 from "../assets/dionisiache/image_2016.jpg";
import image_2017 from "../assets/dionisiache/image_2017.jpg";
import image_2018 from "../assets/dionisiache/image_2018.jpg";
import image_2019 from "../assets/dionisiache/image_2019.jpg";
import image_2020 from "../assets/dionisiache/image_2020.jpg";

import classes from "./css/Dionisiache.module.css";

const DionisiachePage = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [selectedImage, setSelectedImage] = useState();

  const onClickHandler = (img) => {
    if (window.innerWidth < 716) {
      return;
    }

    setIsClicked(true);
    setSelectedImage(img);
    document.body.style.overflow = "hidden";
  };

  const onCloseHandler = () => {
    setIsClicked(false);
    document.body.style.overflow = "unset";
  };

  return (
    <>
      {isClicked && (
        <Modal
          onClose={onCloseHandler}
          image={selectedImage}
          type={"dionisiache"}
        />
      )}
      <div className={classes.main_dionisiache}>
        <div className={classes.info_dionisiache}>
          <div className={classes.span_main}>
            <span>Dionis</span>
            <span>iache</span>

            <div className={classes.trademark_main}>
              <sup className={classes.trademark}>®</sup>
            </div>
          </div>

          <h2>Teatro Festival</h2>
        </div>

        <img src={header_image_2021} alt="show detail" />

        <div className={classes.description}>
          <p>
            Il progetto culturale DIONISIACHE, benché ideato qualche anno prima,
            prende vita nel 2015 quando il Comune di Calatafimi Segesta, a
            seguito di un Avviso di Gara, sceglie il progetto per valorizzare il
            suo territorio. Il Comune, congiuntamente al Parco Archeologico di
            Segesta, diventa organizzatore del FESTIVAL DIONISIACHE e rimane
            tale fino al 2018. Successivamente all’istituzione dell’autonomia
            dei Parchi archeologici siciliani, all’organizzazione del Festival
            subentra il Parco Archeologico di Segesta. <br/><br/>Negli anni il Festival
            Dionisiache si posiziona tra i maggiori e rilevanti eventi teatrali
            estivi del territorio italiano. A contribuire a tale risultato: a)
            la qualità artistica delle proposte nelle varie programmazioni; b)
            l’apertura del Teatro di Segesta a tutte le realtà
            artistiche/culturali del territorio; c) l’opportunità a giovani
            compagnie, di indiscussa qualità, a essere presenti nelle varie
            programmazioni; d) le residenze creative (spazio prove e assistenza
            tecnica logistica gratuita); e) il coinvolgimento di importanti nomi
            della cultura e dello spettacolo; e soprattutto una squadra di
            bravissimi collaboratori e l’accoglienza di tutta la città di
            Calatafimi Segesta. <br/><br/>Il progetto Dionisiache è stato promotore del
            Premio di drammaturgia Cendic Segesta e del prestigioso “Progetto
            Segesta” (collaborando con l’Università di Palermo e il suo
            Dipartimento di Scienze Umanistiche, il Parco Archeologico di
            Segesta e il Comune di Calatafimi Segesta). Nel 2017 il Direttore
            Artistico del Festival, ideatore del progetto, riceve il prestigioso
            premio OMBRA DELLA SERA dall’ importante Festival Internazionale
            Teatro Romano di Volterra. Nel 2021 al Parco di Naxos il Progetto
            Dionisiache ha contribuito a far assegnare al Parco Archeologico di
            Segesta il premio "COMUNICARE L’ANTICO 2021" per la sezione Eventi
            le Dionisiache di Segesta per l’impegno e la valorizzazione del sito
            attraverso la rassegna “Dionisiache”, che ogni estate anima il Parco
            Archeologico. I manifesti delle ultime 5 edizioni, che hanno
            rafforzato l’identità del progetto, sono di Angela Gallaro Goracci
          </p>
        </div>

        <a className={classes.button} href="https://www.dionisiache.it/">
          Collegati al sito ufficiale
        </a>

        <div className={classes.grid_dionisiache}>
          <ImageOnGrid
            onClick={() => onClickHandler(image_2020)}
            image={image_2020}
            type={"dionisiache"}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(image_2019)}
            image={image_2019}
            type={"dionisiache"}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(image_2018)}
            image={image_2018}
            type={"dionisiache"}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(image_2017)}
            image={image_2017}
            type={"dionisiache"}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(image_2016)}
            image={image_2016}
            type={"dionisiache"}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(image_2015)}
            image={image_2015}
            type={"dionisiache"}
          />
        </div>
      </div>
    </>
  );
};

export default DionisiachePage;
